export default "__VITE_ASSET__c9d549e0__"